import { Button } from "@src/appV2/redesign/components/Button";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

interface TimekeepingActionButtonProps {
  title: string;
  onClick: () => void;
}

export function TimekeepingActionButton(props: TimekeepingActionButtonProps) {
  const { title, onClick } = props;

  return (
    <Button
      startIconType="clock"
      variant={isRebrandingEnabled() ? "brand" : undefined}
      size={isRebrandingEnabled() ? "large" : undefined}
      sx={(theme) => ({
        ...(isRebrandingEnabled() ? {} : { boxShadow: theme.shadows[3] }),
      })}
      onClick={onClick}
    >
      {title}
    </Button>
  );
}
